import { render, staticRenderFns } from "./DevStatus2.vue?vue&type=template&id=6842f5be&scoped=true"
import script from "./DevStatus2.vue?vue&type=script&lang=js"
export * from "./DevStatus2.vue?vue&type=script&lang=js"
import style0 from "./DevStatus2.vue?vue&type=style&index=0&id=6842f5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842f5be",
  null
  
)

export default component.exports